import React from "react"

function guideIconsSecond(props) {
    switch (props.number) {
        case 0:
            return (
                <svg viewBox="0 0 50 50" {...props}>
                    <path d="M49.6 14.3L25.4.1c-.3-.1-.6-.2-.8 0L.4 13.4c-.2.2-.4.5-.4.8v35c0 .4.4.8.8.8H5c.5 0 .8-.4.8-.8V20h38.3v29.2c0 .5.4.8.8.8h4.2c.5 0 .8-.4.8-.8V15c.1-.3-.1-.6-.3-.7zm-1.3 34h-2.5V19.2c0-.5-.4-.8-.8-.8H5c-.5 0-.8.4-.8.8v29.2H1.7V14.7L25 1.8l23.3 13.7v32.8z" />
                    <path d="M41.7 38.3h-10c-.5 0-.8.4-.8.8v10c0 .5.4.8.8.8h10c.5 0 .8-.4.8-.8v-10c0-.4-.4-.8-.8-.8zm-.9 10h-8.3V40h8.3v8.3z" />
                    <path d="M37.5 39.2v2.5h-1.7v-2.5h-1.7v3.3c0 .5.4.8.8.8h3.3c.5 0 .8-.4.8-.8v-3.3h-1.5zM31.7 38.3h-10c-.5 0-.8.4-.8.8v10c0 .5.4.8.8.8h10c.5 0 .8-.4.8-.8v-10c0-.4-.4-.8-.8-.8zm-.9 10h-8.3V40h8.3v8.3z" />
                    <path d="M27.5 39.2v2.5h-1.7v-2.5h-1.7v3.3c0 .5.4.8.8.8h3.3c.5 0 .8-.4.8-.8v-3.3h-1.5zM41.7 28.3h-10c-.5 0-.8.4-.8.8v10c0 .5.4.8.8.8h10c.5 0 .8-.4.8-.8v-10c0-.4-.4-.8-.8-.8zm-.9 10h-8.3V30h8.3v8.3z" />
                    <path d="M37.5 29.2v2.5h-1.7v-2.5h-1.7v3.3c0 .5.4.8.8.8h3.3c.5 0 .8-.4.8-.8v-3.3h-1.5zM5 25h40v1.7H5zM5 21.7h40v1.7H5zM29.2 11.7h-8.3c-.5 0-.8.4-.8.8v3.3c0 .5.4.8.8.8h8.3c.5 0 .8-.4.8-.8v-3.3c0-.5-.4-.8-.8-.8zm-.9 3.3h-6.7v-1.7h6.7V15z" />
                    <path
                        d="M32.6 18.9C29.4 15.7 25.2 14 21 14s-8.4 1.7-11.6 4.9c-6.5 6.5-6.5 16.8 0 23.3C12.6 45.3 16.8 47 21 47s8.4-1.7 11.6-4.9c6.5-6.5 6.5-16.8 0-23.2zm-20.5 2.7c2.5-2.4 5.7-3.8 8.9-3.8 2.5 0 5.1.8 7.3 2.4L21 27.5 10.7 37.8c-3.6-5.2-3.1-11.7 1.4-16.2zm17.8 17.8c-2.5 2.4-5.7 3.8-8.9 3.8-2.5 0-5.1-.8-7.3-2.4l17.6-17.6c3.6 5.1 3.1 11.7-1.4 16.2z"
                        fill="#ff4949"
                    />
                    <path
                        d="M32.6 42.1C29.4 45.3 25.2 47 21 47v-3.9c3.2 0 6.4-1.3 8.9-3.8 4.5-4.5 5-11.1 1.4-16.2L21 33.4v-5.9l7.3-7.3c-2.2-1.6-4.8-2.4-7.3-2.4V14c4.2 0 8.4 1.7 11.6 4.9 6.5 6.4 6.5 16.7 0 23.2z"
                        fill="#ff193d"
                    />
                </svg>
            )
        case 1:
            return (
                <svg viewBox="0 0 50 50" {...props}>
                    <path d="M16.8 38.3c0-.1 0-.1-.1-.2 0-.1-.1-.1-.1-.2s-.1-.1-.1-.1l-.1-.1c-.1 0-.1-.1-.2-.1s-.1 0-.2-.1h-.4c-.1 0-.1 0-.2.1-.1 0-.1.1-.2.1s-.1.1-.1.1l-.1.1v.2c0 .1 0 .1-.1.2v.4c0 .1 0 .1.1.2 0 .1.1.1.1.2s.1.1.1.1l.1.1c.1 0 .1.1.2.1s.1 0 .2.1h.4c.1 0 .1 0 .2-.1.1 0 .1-.1.2-.1s.1-.1.1-.1l.1-.1c0-.1.1-.1.1-.2s0-.1.1-.2v-.2c0-.1 0-.2-.1-.2z" />
                    <path d="M44.9 38.6c0-.1 0-.1 0 0-.9-2.1-3-2.9-5.5-2.1l-6.8 1.9c-.4-1.2-1.4-2.2-2.8-2.7l-7.5-2.5c-.6-.8-2.6-2.9-6.2-2.9-2.6 0-4.8 1.7-6.1 3.7H1c-.5 0-1 .4-1 1v12.3c0 .5.4 1 1 1h5.8c.5 0 1-.4 1-1v-.8h2.7c.5 0 1-.4 1-1v-.3c1.6.1 2.1.4 3.6 1.3 1.1.6 2.8 1.6 5.9 3 .6.2 1.7.6 3.1.6 1 0 2.1-.2 3.2-.7l15-5.4h.1c1.5-.8 3.6-2.7 2.5-5.4zM5.8 46.2H2V35.9h3.9v10.3zm3.7-1.8H7.8v-8.5h1.7v8.5zm32.1-2.3l-15 5.4c-2.1 1-4.1.4-4.9.1-2.9-1.3-4.5-2.2-5.7-2.9-1.6-.9-2.4-1.4-4.5-1.5v-7.9c.9-1.5 2.7-3.1 4.7-3.1 3.3 0 4.7 2.2 4.8 2.2.1.2.3.3.5.4l7.8 2.6c1.2.5 1.9 1.5 1.6 2.6-.1.5-.5.9-.9 1.1-.4.2-.9.3-1.4.2l-8.7-2.8c-.5-.2-1.1.1-1.2.6-.2.5.1 1.1.6 1.2l8.8 2.8c.3.1.7.1 1.1.1.6 0 1.3-.2 1.9-.5.9-.5 1.5-1.3 1.8-2.3 0-.1 0-.2.1-.2l7.3-2c1.1-.4 2.4-.5 3.1.9.3 1.9-1.3 2.8-1.8 3zM35.1 12.8c0-.1 0-.1-.1-.2 0-.1-.1-.1-.1-.2s-.1-.1-.1-.1l-.1-.1c-.1 0-.1-.1-.2-.1s-.1 0-.2-.1h-.4c-.1 0-.1 0-.2.1-.1 0-.1.1-.2.1s-.1.1-.1.1l-.1.1c0 .1-.1.1-.1.2s0 .1-.1.2v.4c0 .1 0 .1.1.2 0 .1.1.1.1.2s.1.1.1.1l.1.1c.1 0 .1.1.2.1s.1 0 .2.1h.4c.1 0 .1 0 .2-.1.1 0 .1-.1.2-.1s.1-.1.1-.1l.1-.1c0-.1.1-.1.1-.2s0-.1.1-.2 0-.1 0-.2v-.2z" />
                    <path d="M49 3.3h-5.8c-.5 0-1 .4-1 1v.8h-2.7c-.5 0-1 .4-1 1v.3c-1.6-.1-2.1-.4-3.6-1.3-1.1-.6-2.8-1.6-5.9-3-1-.4-3.6-1.2-6.4.1l-3.9 1.4L15.4.3c-.4-.4-1-.4-1.4 0L3.2 11.2c-.4.4-.4 1 0 1.4l18.6 18.6c.3.3 1 .4 1.4 0l9.9-9.9h.8c2.6 0 4.8-1.7 6.1-3.7h9c.5 0 1-.4 1-1V4.3c0-.6-.5-1-1-1zm-34.3-.9L17 4.6c-.7.4-1.4.6-2.2.6-.8 0-1.6-.2-2.2-.6l2.1-2.2zM7.5 14.1l-2.2-2.2 2.2-2.2c.4.7.6 1.4.6 2.2 0 .7-.2 1.5-.6 2.2zm15 14.9l-2.2-2.2c1.4-.8 3.1-.8 4.4 0L22.5 29zm3.6-3.6c-2.2-1.6-5.1-1.6-7.3 0l-9.9-9.9c.8-1 1.2-2.3 1.2-3.6 0-1.3-.4-2.6-1.2-3.6L11.1 6c1 .8 2.3 1.2 3.6 1.2 1.3 0 2.6-.4 3.6-1.2l2.1 2.1c-.5.1-.9.2-1.3.4-.7.4-1.2 1-1.6 1.7-1.1.2-2.1.7-2.9 1.5-2.2 2.2-2.2 5.7 0 7.9 1.1 1.1 2.5 1.6 3.9 1.6s2.9-.5 3.9-1.6c.7-.7 1.2-1.6 1.4-2.5l3.3 1.1c-.4 1.7 0 3.5 1 4.9l-2 2.3zm-6-9.6c.1 0 .1 0 0 0l2 .7c-.1.7-.5 1.3-1 1.8-1.4 1.4-3.7 1.4-5.1 0a3.621 3.621 0 011.2-5.9c.2 1.5 1.3 2.8 2.9 3.4zm9.6 6c-.4-.6-.6-1.3-.6-2 .5.3 1 .7 1.7.9l-1.1 1.1zm8.8-5.6c-.9 1.5-2.7 3.1-4.7 3.1-.4 0-.7 0-1-.1-2.1-.3-3.2-1.5-3.6-2 0 0-.1-.1-.1-.2-.1-.2-.3-.4-.5-.4L20.8 14c-1.2-.5-1.9-1.5-1.6-2.6.1-.5.5-.9.9-1.1.4-.2.9-.3 1.4-.2l8.7 2.8c.5.2 1.1-.1 1.2-.6s-.1-1.1-.6-1.2l-7-2.2-.1-.1-3.6-3.6L23.4 4c2.1-1 4.1-.4 4.9-.1 2.9 1.3 4.5 2.2 5.7 2.9 1.6.9 2.4 1.4 4.5 1.5v7.9zm3.7-.6h-1.7V7.1h1.7v8.5zm5.8 0h-3.9V5.3H48v10.3z" />
                </svg>
            )
        case 2:
            return (
                <svg viewBox="0 0 50 50" {...props}>
                    <path d="M49.7 8L32.3.1c-.2-.1-.4-.1-.6 0L14.3 7.5c-.2.1-.3.3-.3.4v19.6c0 .3.3.5.6.5h3c.3 0 .6-.2.6-.5V11.2h27.6v16.3c0 .3.3.5.6.5h3c.3 0 .6-.2.6-.5V8.4c0-.2-.1-.3-.3-.4zm-.9 19.1H47V10.7c0-.3-.3-.5-.6-.5H17.6c-.3 0-.6.2-.6.5V27h-1.8V8.2L32 1l16.8 7.7v18.4z" />
                    <path d="M45.2 21.8h-8c-.4 0-.7.2-.7.5v6.2c0 .3.3.5.7.5h8c.4 0 .7-.2.7-.5v-6.2c-.1-.3-.4-.5-.7-.5zm-.7 6.2h-6.7v-5.2h6.7V28z" />
                    <path d="M41.8 22.3v1.5h-1.3v-1.5h-1.3v2.1c0 .3.3.5.7.5h2.7c.4 0 .7-.2.7-.5v-2.1h-1.5zM37.1 21.8h-8c-.4 0-.7.2-.7.5v6.2c0 .3.3.5.7.5h8c.4 0 .7-.2.7-.5v-6.2c0-.3-.3-.5-.7-.5zm-.6 6.2h-6.7v-5.2h6.7V28z" />
                    <path d="M33.8 22.3v1.5h-1.3v-1.5h-1.3v2.1c0 .3.3.5.7.5h2.7c.4 0 .7-.2.7-.5v-2.1h-1.5zM45.3 15h-7.8c-.4 0-.7.2-.7.5v6c0 .3.3.5.7.5h7.8c.4 0 .7-.2.7-.5v-6c0-.3-.3-.5-.7-.5zm-.6 6h-6.5v-5h6.5v5z" />
                    <path d="M41 16.3v1.4h-1.2v-1.4h-1.2v1.9c0 .3.3.5.6.5h2.4c.3 0 .6-.2.6-.5v-1.9H41zM17.6 14h28.8v.9H17.6zM17.6 12.1h28.8v.9H17.6zM35 6.5h-6c-.3 0-.6.2-.6.5v1.9c0 .3.3.5.6.5h6c.3 0 .6-.2.6-.5V7c0-.3-.3-.5-.6-.5zm-.6 1.9h-4.8v-.9h4.8v.9zM7.7 42.5c-1.8 0-3.3 1.4-3.3 3.2s1.5 3.2 3.3 3.2 3.3-1.4 3.3-3.2c0-1.8-1.5-3.2-3.3-3.2zm0 5.3c-1.2 0-2.2-1-2.2-2.1 0-1.2 1-2.1 2.2-2.1 1.2 0 2.2 1 2.2 2.1 0 1.2-1 2.1-2.2 2.1zM26.4 42.5c-1.8 0-3.3 1.4-3.3 3.2s1.5 3.2 3.3 3.2c1.8 0 3.3-1.4 3.3-3.2 0-1.8-1.5-3.2-3.3-3.2zm0 5.3c-1.2 0-2.2-1-2.2-2.1 0-1.2 1-2.1 2.2-2.1 1.2 0 2.2 1 2.2 2.1 0 1.2-1 2.1-2.2 2.1z" />
                    <path d="M32.9 39.6l-5-7.5c-.1-.2-.3-.2-.5-.2h-6c-.3 0-.5.2-.5.5v13.3c0 .3.2.5.5.5h2.2v-1.1H22V32.9h5.2l4.7 7.1v5.2h-2.8v1.1h3.3c.3 0 .5-.2.5-.5v-5.9c.1-.2.1-.3 0-.3z" />
                    <path d="M24.2 38.8v-3.7h4.4V34h-5c-.3 0-.5.2-.5.5v4.8c0 .3.2.5.5.5h8.3v-1.1l-7.7.1zM21.5 28.1H.5c-.3 0-.5.2-.5.5v17c0 .3.2.5.5.5H5V45H1.1V29h19.8v16H10.4v1.1h11c.3 0 .5-.2.5-.5v-17c.1-.2-.1-.5-.4-.5z" />
                    <path d="M.5 43h3.3v1.1H.5zM11.6 43H21v1.1h-9.4zM30.3 43h2.2v1.1h-2.2zM2.2 30.3h19.3v1.1H2.2zM7.1 45.2h1.1v1.1H7.1zM25.9 45.2H27v1.1h-1.1zM2.2 26h7.7v1.1H2.2zM0 26h1.1v1.1H0z" />
                </svg>
            )
        case 3:
            return (
                <svg viewBox="0 0 50 50" {...props}>
                    <path d="M49.6 14.3L25.4.1c-.3-.1-.6-.2-.8 0L.4 13.4c-.2.2-.4.5-.4.8v35c0 .4.4.8.8.8H5c.5 0 .8-.4.8-.8V20h38.3v29.2c0 .5.4.8.8.8h4.2c.5 0 .8-.4.8-.8V15c.1-.3-.1-.6-.3-.7zm-1.3 34h-2.5V19.2c0-.5-.4-.8-.8-.8H5c-.5 0-.8.4-.8.8v29.2H1.7V14.7L25 1.8l23.3 13.7v32.8z" />
                    <path d="M41.7 38.3h-10c-.5 0-.8.4-.8.8v10c0 .5.4.8.8.8h10c.5 0 .8-.4.8-.8v-10c0-.4-.4-.8-.8-.8zm-.9 10h-8.3V40h8.3v8.3z" />
                    <path d="M37.5 39.2v2.5h-1.7v-2.5h-1.7v3.3c0 .5.4.8.8.8h3.3c.5 0 .8-.4.8-.8v-3.3h-1.5zM31.7 38.3h-10c-.5 0-.8.4-.8.8v10c0 .5.4.8.8.8h10c.5 0 .8-.4.8-.8v-10c0-.4-.4-.8-.8-.8zm-.9 10h-8.3V40h8.3v8.3z" />
                    <path d="M27.5 39.2v2.5h-1.7v-2.5h-1.7v3.3c0 .5.4.8.8.8h3.3c.5 0 .8-.4.8-.8v-3.3h-1.5zM41.7 28.3h-10c-.5 0-.8.4-.8.8v10c0 .5.4.8.8.8h10c.5 0 .8-.4.8-.8v-10c0-.4-.4-.8-.8-.8zm-.9 10h-8.3V30h8.3v8.3z" />
                    <path d="M37.5 29.2v2.5h-1.7v-2.5h-1.7v3.3c0 .5.4.8.8.8h3.3c.5 0 .8-.4.8-.8v-3.3h-1.5zM5 25h40v1.7H5zM5 21.7h40v1.7H5zM29.2 11.7h-8.3c-.5 0-.8.4-.8.8v3.3c0 .5.4.8.8.8h8.3c.5 0 .8-.4.8-.8v-3.3c0-.5-.4-.8-.8-.8zm-.9 3.3h-6.7v-1.7h6.7V15z" />
                    <path
                        d="M34 15c-.8 0-1.5.2-2.2.6-8.5 4.5-14.2 13.1-17.3 18.6L8.9 30C8 29.3 7 29 6 29c-1.6 0-3.2.9-4.1 2.3-1.6 2.4-1.1 5.8 1.2 7.5L10 44c1.5 1.1 3.2 1.8 5 1.8.6 0 1.2-.1 1.9-.2 2.4-.6 4.5-2.3 5.7-4.7 2.2-4.2 6.9-11.9 13.6-15.5 1.2-.6 2.1-1.7 2.5-3.1.4-1.4.3-2.8-.3-4.1-.8-2-2.5-3.2-4.4-3.2zm2.3 6.3c-.2.7-.7 1.2-1.3 1.6-7.4 3.9-12.4 12.1-14.7 16.6-.9 1.8-2.4 3-4.1 3.4-1.7.4-3.4 0-4.8-1.1l-6.9-5.2c-1.1-.9-1.3-2.6-.5-3.8.4-.8 1.2-1.2 2-1.2.5 0 1 .2 1.4.5l7.8 6 .7-1.3c2.6-5.1 8.3-14.2 16.9-18.8.3-.2.7-.3 1.1-.3 1 0 1.8.6 2.3 1.5.3.7.4 1.4.1 2.1z"
                        fill="#0f0"
                    />
                </svg>
            )
        case 4:
            return (
                <svg
                    id="prefix__Warstwa_1"
                    x={0}
                    y={0}
                    viewBox="0 0 50 50"
                    xmlSpace="preserve"
                >
                    <style>
                        {
                            ".prefix__st0{fill:#00969b}.prefix__st1{fill:#00ccb3}.prefix__st2{fill:#7d0}.prefix__st3{fill:#6b0}.prefix__st4{fill:#e7e7e7}.prefix__st5{fill:#d3d3d8}"
                        }
                    </style>
                    <path d="M47 0H3C1.4 0 0 1.5 0 3.4v34.1c0 1.9 1.4 3.4 3 3.4h15.1v2.5c0 2.3-1.6 4.1-3.7 4.1h-3.3c-.6 0-1.2.6-1.2 1.3 0 .7.5 1.3 1.2 1.3h27.8c.6 0 1.2-.6 1.2-1.3 0-.7-.5-1.3-1.2-1.3h-3.3c-2 0-3.7-1.8-3.7-4.1v-2.5H47c1.7 0 3-1.5 3-3.4V3.4C50 1.5 48.6 0 47 0zM19.1 47.4c.8-1.1 1.3-2.6 1.3-4.1v-2.5h9.2v2.5c0 1.5.5 3 1.3 4.1H19.1zm28.6-9.9c0 .4-.3.8-.7.8H3c-.4 0-.7-.4-.7-.8v-6.8h45.4v6.8zm0-9.4H2.3V3.4c0-.4.3-.8.7-.8h44c.4 0 .7.4.7.8v24.7z" />
                    <ellipse cx={25} cy={34.5} rx={1.2} ry={1.4} />
                    <path
                        className="prefix__st0"
                        d="M29 5H18l-.9 1.6.9 1.5h11V5zM29 17.6H18l-.9 1.6.9 1.6h11v-3.2zM26.3 14.4v-3.1H18l-.9 1.6.9 1.6h8.3zM26.3 27v-3.1H18l-.9 1.6.9 1.5h8.3z"
                    />
                    <path
                        className="prefix__st1"
                        d="M7 5h11v3.1H7V5zM7 11.3h11v3.1H7v-3.1zM7 17.6h11v3.1H7v-3.1zM7 23.9h11V27H7v-3.1z"
                    />
                    <path
                        className="prefix__st2"
                        d="M39 3.5c-1.5 0-2.8 1.2-2.8 2.8S37.5 9 39 9s2.8-1.2 2.8-2.8-1.3-2.7-2.8-2.7z"
                    />
                    <path
                        className="prefix__st3"
                        d="M41.8 6.3C41.8 7.8 40.5 9 39 9V3.5c1.5 0 2.8 1.2 2.8 2.8z"
                    />
                    <path
                        className="prefix__st4"
                        d="M40.7 5.7L39 7.2l-.3.3-1.2-1.2.4-.5.8.8.3-.3 1.2-1.1z"
                    />
                    <path className="prefix__st5" d="M40.7 5.7L39 7.2v-.9l1.2-1.1z" />
                    <path
                        className="prefix__st2"
                        d="M39 9.5c-1.5 0-2.8 1.2-2.8 2.8S37.5 15 39 15s2.8-1.2 2.8-2.8-1.3-2.7-2.8-2.7z"
                    />
                    <path
                        className="prefix__st3"
                        d="M41.8 12.3c0 1.5-1.2 2.8-2.8 2.8V9.5c1.5 0 2.8 1.2 2.8 2.8z"
                    />
                    <path
                        className="prefix__st4"
                        d="M40.7 11.7L39 13.2l-.3.3-1.2-1.2.4-.5.8.8.3-.3 1.2-1.1z"
                    />
                    <path className="prefix__st5" d="M40.7 11.7L39 13.2v-.9l1.2-1.1z" />
                    <path
                        className="prefix__st2"
                        d="M39 15.5c-1.5 0-2.8 1.2-2.8 2.8S37.5 21 39 21s2.8-1.2 2.8-2.8-1.3-2.7-2.8-2.7z"
                    />
                    <path
                        className="prefix__st3"
                        d="M41.8 18.3c0 1.5-1.2 2.8-2.8 2.8v-5.5c1.5-.1 2.8 1.1 2.8 2.7z"
                    />
                    <path
                        className="prefix__st4"
                        d="M40.7 17.7L39 19.2l-.3.3-1.2-1.2.4-.5.8.8.3-.3 1.2-1.1z"
                    />
                    <path className="prefix__st5" d="M40.7 17.7L39 19.2v-.9l1.2-1.1z" />
                    <path
                        className="prefix__st2"
                        d="M39 21.5c-1.5 0-2.8 1.2-2.8 2.8S37.5 27 39 27s2.8-1.2 2.8-2.8-1.3-2.7-2.8-2.7z"
                    />
                    <path
                        className="prefix__st3"
                        d="M41.8 24.3c0 1.5-1.2 2.8-2.8 2.8v-5.5c1.5-.1 2.8 1.1 2.8 2.7z"
                    />
                    <path
                        className="prefix__st4"
                        d="M40.7 23.7L39 25.2l-.3.3-1.2-1.2.4-.5.8.8.3-.3 1.2-1.1z"
                    />
                    <path className="prefix__st5" d="M40.7 23.7L39 25.2v-.9l1.2-1.1z" />
                </svg>
            )
        case 5:
            return (
                <svg
                    id="prefix__Capa_1"
                    x={0}
                    y={0}
                    viewBox="0 0 512 512"
                    xmlSpace="preserve"
                >
                    <style>
                        {
                            ".prefix__st0{fill:#4d4d4d}.prefix__st1{fill:#737373}.prefix__st5{fill:#d5f6f5}"
                        }
                    </style>
                    <path d="M507.8 146.2L260.3 1.2c-2.6-1.5-5.8-1.6-8.4-.1L4.4 137.6C1.7 139.1 0 142 0 145.1v358.4c0 4.7 3.8 8.5 8.5 8.5h42.7c4.7 0 8.5-3.8 8.5-8.5V204.8h392.5v298.7c0 4.7 3.8 8.5 8.5 8.5h42.7c4.7 0 8.5-3.8 8.5-8.5V153.6c.1-3-1.5-5.8-4.1-7.4zm-12.9 348.7h-25.6V196.3c0-4.7-3.8-8.5-8.5-8.5H51.2c-4.7 0-8.5 3.8-8.5 8.5V495H17.1V150.1L255.9 18.3 495 158.4l-.1 336.5z" />
                    <path d="M426.7 392.5H324.3c-4.7 0-8.5 3.8-8.5 8.5v102.4c0 4.7 3.8 8.5 8.5 8.5h102.4c4.7 0 8.5-3.8 8.5-8.5V401.1c0-4.8-3.8-8.6-8.5-8.6zm-8.6 102.4h-85.3v-85.3h85.3v85.3z" />
                    <path d="M384 401.1v25.6h-17.1v-25.6h-17.1v34.1c0 4.7 3.8 8.5 8.5 8.5h34.1c4.7 0 8.5-3.8 8.5-8.5v-34.1H384zM324.3 392.5H221.9c-4.7 0-8.5 3.8-8.5 8.5v102.4c0 4.7 3.8 8.5 8.5 8.5h102.4c4.7 0 8.5-3.8 8.5-8.5V401.1c0-4.8-3.8-8.6-8.5-8.6zm-8.6 102.4h-85.3v-85.3h85.3v85.3z" />
                    <path d="M281.6 401.1v25.6h-17.1v-25.6h-17.1v34.1c0 4.7 3.8 8.5 8.5 8.5H290c4.7 0 8.5-3.8 8.5-8.5v-34.1h-16.9zM426.7 290.1H324.3c-4.7 0-8.5 3.8-8.5 8.5V401c0 4.7 3.8 8.5 8.5 8.5h102.4c4.7 0 8.5-3.8 8.5-8.5V298.7c0-4.8-3.8-8.6-8.5-8.6zm-8.6 102.4h-85.3v-85.3h85.3v85.3z" />
                    <path d="M384 298.7v25.6h-17.1v-25.6h-17.1v34.1c0 4.7 3.8 8.5 8.5 8.5h34.1c4.7 0 8.5-3.8 8.5-8.5v-34.1H384zM51.2 256h409.6v17.1H51.2zM51.2 221.9h409.6V239H51.2zM298.7 119.5h-85.3c-4.7 0-8.5 3.8-8.5 8.5v34.1c0 4.7 3.8 8.5 8.5 8.5h85.3c4.7 0 8.5-3.8 8.5-8.5V128c0-4.7-3.8-8.5-8.5-8.5zm-8.6 34.1h-68.3v-17.1h68.3v17.1z" />
                    <path
                        className="prefix__st0"
                        d="M32.7 420.9c11.9 11.9 31.2 11.9 43 0l7.2-7.2-26.3-45.4-23.9 52.6zM159.3 294.3l-60.9 41.8 45.4 16.7 37.1-37z"
                    />
                    <path
                        className="prefix__st1"
                        d="M39.9 370.7l-7.2 7.2c-11.9 11.9-11.9 31.2 0 43l28.7-28.7-21.5-21.5z"
                    />
                    <path
                        transform="rotate(-45.001 130.044 302.03)"
                        className="prefix__st1"
                        d="M103.8 286.8h52.4v30.4h-52.4z"
                    />
                    <path d="M61.4 392.2l21.5 21.5 60.9-60.9-21.5-21.5-40 20.9z" />
                    <path
                        transform="rotate(-45.001 81.084 350.992)"
                        fill="#272727"
                        d="M38.1 335.8h86.1v30.4H38.1z"
                    />
                    <path
                        className="prefix__st1"
                        d="M331.3 122.3l-112.9 74.6-74.6 112.9c51.8 51.8 135.7 51.8 187.5 0s51.7-135.7 0-187.5z"
                    />
                    <path
                        d="M143.8 122.3C92 174.1 92 258 143.8 309.8l187.5-187.5c-51.8-51.7-135.7-51.7-187.5 0z"
                        fill="#969696"
                    />
                    <path
                        d="M306.9 146.7l-88.5 50.2-50.2 88.5c38.3 38.3 100.4 38.3 138.7 0 38.3-38.3 38.3-100.4 0-138.7z"
                        fill="#abecec"
                    />
                    <g>
                        <path
                            className="prefix__st5"
                            d="M168.2 146.7c-38.3 38.3-38.3 100.4 0 138.7l138.7-138.7c-38.3-38.3-100.4-38.3-138.7 0z"
                        />
                        <path
                            className="prefix__st5"
                            d="M292.5 161.1L218.4 197l-35.9 74.1c30.4 30.4 79.6 30.4 110 0 30.4-30.4 30.4-79.7 0-110z"
                        />
                    </g>
                    <path
                        d="M182.5 161.1c-30.4 30.4-30.4 79.6 0 110l110-110c-30.3-30.4-79.6-30.4-110 0z"
                        fill="#fff"
                    />
                </svg>
            )
        case 6:
            return (
                <svg
                    id="prefix__Warstwa_7"
                    x={0}
                    y={0}
                    viewBox="0 0 50 50"
                    xmlSpace="preserve"
                    {...props}
                >
                    <style>
                        {
                            ".prefix__st0,.prefix__st2{stroke:#000;stroke-width:.25;stroke-miterlimit:10}.prefix__st2{fill:none;stroke-width:.5}"
                        }
                    </style>
                    <path
                        className="prefix__st0"
                        d="M20 28H5c-2.8 0-5 2.3-5 5.2v8.6c0 2.8 2.2 5.1 4.9 5.1H20.3c2.6-.1 4.6-2.3 4.6-5v-8.8c0-2.8-2.2-5.1-4.9-5.1zm3.2 14.2c0 1.6-1.3 3.2-2.9 3.2H4.2c-1.5-.1-2.6-1.4-2.6-3v-9.6c0-1.7 1.3-3 2.9-3h15.8c1.6 0 2.9 1.3 2.9 3v9.4z"
                    />
                    <path
                        className="prefix__st0"
                        d="M5.9 44V30.7h-1c-1.2 0-2.1 1-2.1 2.2v8.9c0 1.2 1 2.2 2.1 2.2h1zM15.3 30.7H18V44h-2.7zM9.9 30.7h2V44h-2zM13 30.7h1.1V44H13zM7 30.7h1.8V44H7zM19.1 30.7V44h.9c1.2 0 2.1-1 2.1-2.2v-8.9c0-1.2-1-2.2-2.1-2.2h-.9z"
                    />
                    <path
                        d="M48.3 46.7h-.8c-.5 0-1-.7-1.2-1.2L38 19.3c3-1.2 5.2-4.3 5.2-7.9 0-4.1-2.9-7.7-6.8-8.3L16.7.1c-1.1-.2-2.3.2-3.2.9-.9.8-1.4 1.9-1.4 3v14.6c0 1.2.6 2.3 1.4 3.1.9.8 2 1.1 3.1.9l9.4-1.5s2.2 7 2.1 7c.1.6.1 1.2-.1 1.8l-.4 1.4c-.3.9 0 1.8.7 2.3l1.1.8c1 .7 1.5 2 1.3 3.2 0 0 0 0 0 0 0 .2 0 .3-.1.4l-.5 1.7c-.1.8.2 1.6.8 2.1l1.1.8c1 .7 1.2 1.6 1.2 1.6.1.4.1.8-.2 1.2-.2.3-.6.5-1 .5-.9 0-1.7 1-1.7 2s.8 2 1.7 2h16.1c.9 0 1.7-.7 1.7-1.6.2-.9-.6-1.6-1.5-1.6z"
                        fill="none"
                        stroke="#000"
                        strokeMiterlimit={10}
                    />
                    <g>
                        <path
                            className="prefix__st2"
                            d="M8.9 19c-.6 0-1.1-.5-1.1-1.1V4.5c0-.6.5-1.1 1.1-1.1.6 0 1.1.5 1.1 1.1v13.3c0 .7-.5 1.2-1.1 1.2z"
                        />
                    </g>
                    <g>
                        <path
                            className="prefix__st2"
                            d="M4.4 22.2c-.6 0-1.1-.5-1.1-1.1v-20C3.2.5 3.7 0 4.4 0 5 0 5.5.5 5.5 1.1v20c0 .6-.5 1.1-1.1 1.1z"
                        />
                    </g>
                </svg>
            )
        case 7:
            return (
                <svg viewBox="0 0 50 50">
                    <path d="M49.6 14.3L25.4.1c-.3-.1-.6-.2-.8 0L.4 13.4c-.2.2-.4.5-.4.8v35c0 .4.4.8.8.8H5c.5 0 .8-.4.8-.8V20h38.3v29.2c0 .5.4.8.8.8h4.2c.5 0 .8-.4.8-.8V15c.1-.3-.1-.6-.3-.7zm-1.3 34h-2.5V19.2c0-.5-.4-.8-.8-.8H5c-.5 0-.8.4-.8.8v29.2H1.7V14.7L25 1.8l23.3 13.7v32.8z" />
                    <path d="M41.7 38.3h-10c-.5 0-.8.4-.8.8v10c0 .5.4.8.8.8h10c.5 0 .8-.4.8-.8v-10c0-.4-.4-.8-.8-.8zm-.9 10h-8.3V40h8.3v8.3z" />
                    <path d="M37.5 39.2v2.5h-1.7v-2.5h-1.7v3.3c0 .5.4.8.8.8h3.3c.5 0 .8-.4.8-.8v-3.3h-1.5zM31.7 38.3h-10c-.5 0-.8.4-.8.8v10c0 .5.4.8.8.8h10c.5 0 .8-.4.8-.8v-10c0-.4-.4-.8-.8-.8zm-.9 10h-8.3V40h8.3v8.3z" />
                    <path d="M27.5 39.2v2.5h-1.7v-2.5h-1.7v3.3c0 .5.4.8.8.8h3.3c.5 0 .8-.4.8-.8v-3.3h-1.5zM41.7 28.3h-10c-.5 0-.8.4-.8.8v10c0 .5.4.8.8.8h10c.5 0 .8-.4.8-.8v-10c0-.4-.4-.8-.8-.8zm-.9 10h-8.3V30h8.3v8.3z" />
                    <path d="M37.5 29.2v2.5h-1.7v-2.5h-1.7v3.3c0 .5.4.8.8.8h3.3c.5 0 .8-.4.8-.8v-3.3h-1.5zM5 25h40v1.7H5zM5 21.7h40v1.7H5zM29.2 11.7h-8.3c-.5 0-.8.4-.8.8v3.3c0 .5.4.8.8.8h8.3c.5 0 .8-.4.8-.8v-3.3c0-.5-.4-.8-.8-.8zm-.9 3.3h-6.7v-1.7h6.7V15zM17.3 37.8h-2.5c-.2 0-.4-.1-.4-.3l-.7-3.9c0-.1 0-.2-.1-.2-.1-.3-.4-.5-.8-.5l-4 .2c-.5 0-.9.4-.9.8V43l-.1 1.9c0 .3-.2.9-.4 1.1l-1.7 2.5c-.1.2-.2.5-.1.7.1.2.2.4.5.6l.5.2c.2.1.3.1.5.1.4 0 .7-.2.9-.5l1.7-2.5c.2-.4.5-1 .5-1.4l.5-3.5h.5l2.3 3.2c.2.3.4.8.4 1.1l.3 2.7c0 .4.4.7.8.7.1 0 .2 0 .3-.1l.4-.1c.5-.2.9-.7.8-1.2V46c0-.4-.2-1-.4-1.4l-2.2-4.2v-.8l3.6-.1c.2 0 .5-.1.6-.3.2-.2.2-.4.2-.6-.1-.4-.5-.8-1-.8zM10.2 32.1c.3 0 .6 0 .9-.1.7-.2 1.3-.7 1.6-1.3.3-.6.4-1.3.1-1.9-.4-1-1.5-1.7-2.7-1.7-.3 0-.6 0-.9.1-.7.2-1.3.7-1.6 1.3-.3.6-.4 1.3-.1 1.9.5 1 1.5 1.7 2.7 1.7z" />
                    <g>
                        <path
                            d="M15.6 32.5l1.3.5c.1 0 .6.2 1.5 0 1.1-.3 3.6-.8 3.6-.8l-.1-.5-2.3-.3h-.9l-3.2.6c-.4 0-.8.2-.9.7-.1.2-.1.5.1.7.1.1.1.2.2.3-.1.1-.2.3-.3.5-.1.2-.1.5.1.7.1.1.1.2.2.3-.1.1-.2.3-.3.5-.1.2-.1.5.1.7.1.2.3.4.5.5l2.2.8c.1 0 .3.1.4 0l3.9-1s0-.1-.1-.2c0-.1-.2-.2-.3-.2l-3.6.9h-.4l-2.1-.7c-.1 0-.2-.1-.3-.2-.1-.1-.1-.2 0-.4s.3-.4.6-.3c0 0 1.3.4 1.8.6.1 0 .3.1.4 0l3.9-1s0-.1-.1-.2c0-.1-.2-.2-.3-.2l-3.6.9h-.4l-2.1-.7c-.1 0-.2-.1-.3-.2-.1-.1-.1-.2 0-.4s.3-.4.6-.3c0 0 1.3.4 1.8.6.1 0 .3.1.4 0l3.9-1s0-.1-.1-.2c0-.1-.2-.2-.3-.2l-3.6.9h-.4l-2.1-.7c-.1 0-.2-.1-.3-.2-.1-.1-.1-.2 0-.4.4-.3.7-.5.9-.4z"
                            fill="#010002"
                        />
                    </g>
                </svg>
            )
        case 8:
            return (
                <svg
                    id="prefix__Warstwa_1"
                    x={0}
                    y={0}
                    viewBox="0 0 50 50"
                    xmlSpace="preserve"
                >
                    <style>
                        {
                            ".prefix__st0{fill:none;stroke:#000;stroke-width:.25;stroke-miterlimit:10}"
                        }
                    </style>
                    <circle className="prefix__st0" cx={44.6} cy={42.4} r={5.4} />
                    <circle className="prefix__st0" cx={5.4} cy={42.4} r={5.4} />
                    <circle className="prefix__st0" cx={25} cy={42.4} r={5.4} />
                    <circle className="prefix__st0" cx={5.4} cy={42.4} r={1.3} />
                    <circle className="prefix__st0" cx={25} cy={42.4} r={1.3} />
                    <circle className="prefix__st0" cx={44.6} cy={42.4} r={1.3} />
                    <path
                        className="prefix__st0"
                        d="M37.9 21.9c-.2 0-.5.1-.5.4l-1.2 7.3v-7.3c0-.2-.2-.4-.4-.4s-.4.2-.4.4v11.5H36.5l1.9-11.3c-.1-.3-.2-.5-.5-.6zM20.2 21.9c-.2 0-.4.2-.4.4v11.5h.9V22.3c0-.2-.2-.4-.5-.4zM22.8 21.9c-.2 0-.4.2-.4.4v11.5h.9V22.3c0-.2-.2-.4-.5-.4zM17.6 21.9c-.2 0-.4.2-.4.4v11.5h.9V22.3c0-.2-.2-.4-.5-.4z"
                    />
                    <path
                        className="prefix__st0"
                        d="M18.1 31.4l-.9-5v7.4h.9zM15.1 21.9c-.2 0-.4.2-.4.4v6.6l-1.1-6.6c0-.2-.3-.4-.5-.4s-.4.3-.4.5l1.9 11.3h1V22.3c0-.2-.2-.4-.5-.4zM25.4 21.9c-.2 0-.4.2-.4.4v11.5h.9V22.3c-.1-.2-.2-.4-.5-.4zM28 21.9c-.2 0-.4.2-.4.4v11.5h.9V22.3c-.1-.2-.3-.4-.5-.4zM30.6 21.9c-.2 0-.4.2-.4.4v11.5h.8V22.3c0-.2-.2-.4-.4-.4zM33.2 21.9c-.2 0-.4.2-.4.4v11.5h.9V22.3c-.1-.2-.3-.4-.5-.4z"
                    />
                    <path
                        className="prefix__st0"
                        d="M37.6 26.6H13.3c-.2 0-.4-.2-.4-.4s.2-.4.4-.4h24.3c.2 0 .4.2.4.4.1.2-.1.4-.4.4z"
                    />
                    <path
                        className="prefix__st0"
                        d="M17.1 25.7h-3.8c-.2 0-.4.2-.4.4s.2.4.4.4h3.9l-.1-.8zM36.9 30.4h-23c-.2 0-.4-.2-.4-.4s.2-.4.4-.4H37c.2 0 .4.2.4.4s-.2.4-.5.4z"
                    />
                    <path
                        className="prefix__st0"
                        d="M17.8 29.5h-3.9c-.2 0-.4.2-.4.4s.2.4.4.4h4l-.1-.8zM36.1 35.2l.3-1.5H14.6l.3 1.4c.2 1.1 1.1 1.9 2.3 1.9H34c1 0 1.9-.7 2.1-1.8z"
                    />
                    <path
                        className="prefix__st0"
                        d="M19 35.1l-.3-1.4h-4.1l.3 1.4c.2 1.1 1.1 1.9 2.3 1.9h4.1c-1.2 0-2.1-.8-2.3-1.9zM38.4 19.1h-.5c-.1 0-.2-.1-.2-.2-.1-.8-.8-1.4-1.6-1.4s-1.5.6-1.6 1.4c0 .1-.1.2-.2.2H16.7c-.1 0-.2-.1-.3-.2-.1-.8-.8-1.4-1.6-1.4s-1.5.6-1.6 1.4c0 .1-.1.3-.3.3h-.2c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6h25.7c.9 0 1.6-.7 1.6-1.6 0-1-.7-1.7-1.6-1.7z"
                    />
                    <g>
                        <path
                            className="prefix__st0"
                            d="M14.9 20.7c0-.9.7-1.6 1.6-1.6H16.8h-.2c-.1 0-.2-.1-.3-.2-.1-.8-.8-1.4-1.6-1.4s-1.5.6-1.6 1.4c0 .1-.1.3-.3.3h-.2c-.9 0-1.6.7-1.6 1.6 0 .9.7 1.6 1.6 1.6h3.9c-.9 0-1.6-.8-1.6-1.7zM36.1 19.5c-.1 0-.1 0 0 0-.3 0-.4-.2-.4-.4s.1-.4.4-.4h.2c.2 0 .4.2.4.4-.2.2-.4.4-.6.4z"
                        />
                    </g>
                    <path
                        className="prefix__st0"
                        d="M14.8 19.5c-.2 0-.4-.2-.4-.4s.1-.4.4-.4c.3-.1.5.1.5.4-.1.3-.3.4-.5.4z"
                    />
                    <path
                        d="M27.8.9c-.3-.3-.9-.3-1.3 0-.3.3-.3.8 0 1.1L33 7.6H11.9c-.5 0-.9.3-.9.8s.4.8.9.8H33l-6.4 5.6c-.3.3-.3.8 0 1.1.4.3.9.3 1.3 0L35.8 9c.4-.3.4-.8 0-1.1l-8-7z"
                        fill="#1e201d"
                    />
                    <path className="prefix__st0" d="M0 37h50M50 48H0" />
                </svg>
            )
        case 9:
            return (
                <svg
                    id="prefix__Warstwa_1"
                    x={0}
                    y={0}
                    viewBox="0 0 50 50"
                    xmlSpace="preserve"
                >
                    <style>
                        {
                            ".prefix__st0{fill:none;stroke:#000;stroke-width:.75;stroke-miterlimit:10}"
                        }
                    </style>
                    <path className="prefix__st0" d="M29.8 33.1l13.4 6.4L21.6 50 8.2 43.5z" />
                    <path
                        className="prefix__st0"
                        d="M29.7 23.9L8.2 34.4v9.1l21.6-10.4-.1-9.2"
                    />
                    <path
                        className="prefix__st0"
                        d="M29.7 23.9l-6.1-5.4L2 29l6.2 5.5 21.5-10.6M29.7 23.9l6.2-5.4L49.3 25 43 30.5zM21.6 41v9l21.6-10.5v-9L21.6 41"
                    />
                    <path className="prefix__st0" d="M8.2 34.4v9.1L21.6 50v-9L8.2 34.4" />
                    <ellipse className="prefix__st0" cx={27.1} cy={7.9} rx={11.9} ry={5.5} />
                    <ellipse className="prefix__st0" cx={27.1} cy={8} rx={1.6} ry={0.8} />
                    <path
                        className="prefix__st0"
                        d="M27.1 2C20 2 14.2 4.7 14.2 8s5.7 6 12.8 6 12.8-2.7 12.8-6-5.6-6-12.7-6zm9.4 3.9l-3 .6c-.7-.6-1.8-1.2-3.2-1.5l1.2-1.4c2.2.5 4 1.3 5 2.3zM23.6 7c.3-.3.8-.5 1.3-.6 3.8-.9 7.6.8 5.6 2.6-.3.3-.8.5-1.3.6-3.8 1-7.6-.8-5.6-2.6zm-5.9 3.1l3-.6c.7.6 1.8 1.2 3.2 1.5l-1.2 1.4c-2.2-.4-4-1.3-5-2.3zM11.6 17.1c.2-.2.2-.6 0-.8-.2-.2-.6-.2-.8 0l-4.1 4.2-.2-13.7c0-.3-.3-.6-.6-.6s-.6.3-.6.6l.1 13.7-4.2-4.1c-.2-.2-.6-.2-.8 0-.2.2-.2.6 0 .8l5.2 5.1c.2.2.6.2.8 0l5.2-5.2z"
                    />
                </svg>
            )
        case 10:
            return (
                <svg viewBox="0 0 50 50">
                    <style>
                        {
                            ".prefix__st1,.prefix__st3{fill:none;stroke:#000;stroke-miterlimit:10}.prefix__st1{display:inline;stroke-width:.25}.prefix__st3{stroke-width:.75}"
                        }
                    </style>
                    <g id="prefix__Warstwa_2">
                        <path className="prefix__st3" d="M2 28v12l18 9V37z" />
                        <path className="prefix__st3" d="M20 49l29-14V23L19.7 37z" />
                        <path className="prefix__st3" d="M31 14L2 28l18 9 29-14z" />
                        <path
                            d="M11.8 36.5L9 35.4v-3.1s0-.1.2-.3c.2-.2 1.5-.8 1.5-.8L38.6 18l2.2 1L12 32.9s-.3.2-.3.9.1 2.7.1 2.7"
                            opacity={0.6}
                            fill="none"
                            stroke="#000"
                            strokeWidth={0.75}
                            strokeMiterlimit={10}
                        />
                        <path
                            d="M27.4 1c-.6 0-1.1.1-1.6.4-6.3 3.3-10.6 9.7-12.8 13.8L8.9 12c-.6-.5-1.4-.7-2.1-.7-1.2 0-2.3.6-3 1.7-1.2 1.8-.8 4.3.9 5.6l5.1 3.9c1.1.8 2.4 1.3 3.7 1.3.5 0 .9-.1 1.4-.2 1.8-.4 3.3-1.7 4.2-3.5 1.5-3.2 4.9-8.9 9.9-11.5.9-.5 1.6-1.3 1.9-2.3.3-1 .3-2.1-.2-3.1-.6-1.3-1.9-2.2-3.3-2.2zm1.7 4.6c-.2.5-.5.9-.9 1.2-5.4 2.9-9.2 8.9-10.9 12.3-.7 1.3-1.8 2.2-3 2.5-1.2.3-2.5 0-3.6-.8l-5.1-3.9c-.8-.6-1-1.9-.4-2.8.3-.5.9-.8 1.5-.8.4 0 .8.1 1.1.4l5.8 4.4.5-1C16 13.4 20.2 6.6 26.6 3.2c.2-.1.5-.2.8-.2.7 0 1.4.4 1.7 1.1.2.5.2 1 0 1.5z"
                            fill="#0f0"
                        />
                    </g>
                </svg>
            )
        case 11:
            return (
                <svg
                    id="prefix__Warstwa_1"
                    x={0}
                    y={0}
                    viewBox="0 0 50 50"
                    xmlSpace="preserve"
                >
                    <style>
                        {
                            ".prefix__st0,.prefix__st2{fill:none;stroke:#000;stroke-width:.75;stroke-miterlimit:10}.prefix__st2{stroke-width:.25}"
                        }
                    </style>
                    <circle className="prefix__st0" cx={43.6} cy={42.4} r={5.4} />
                    <circle className="prefix__st0" cx={6.4} cy={42.4} r={5.4} />
                    <circle className="prefix__st0" cx={25} cy={42.4} r={5.4} />
                    <circle className="prefix__st0" cx={6.4} cy={42.4} r={1.3} />
                    <circle className="prefix__st0" cx={25} cy={42.4} r={1.3} />
                    <circle className="prefix__st0" cx={43.6} cy={42.4} r={1.3} />
                    <path
                        d="M27.8.9c-.3-.3-.9-.3-1.3 0-.3.3-.3.8 0 1.1L33 7.6H11.9c-.5 0-.9.3-.9.8s.4.8.9.8H33l-6.4 5.6c-.3.3-.3.8 0 1.1.4.3.9.3 1.3 0L35.8 9c.4-.3.4-.8 0-1.1l-8-7z"
                        fill="#1e201d"
                    />
                    <path className="prefix__st0" d="M0 37h50M50 48H0M10 23h33v14H10z" />
                    <path
                        className="prefix__st2"
                        d="M13.5 29.2H23v4.3h-9.5zM29.5 29.2H39v4.3h-9.5z"
                    />
                </svg>
            )
        case 12:
            return (
                <svg viewBox="0 0 50 50">
                    <path d="M11.7 37.9c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.3-5-5-5zm0 8.3c-1.8 0-3.3-1.5-3.3-3.3 0-1.8 1.5-3.3 3.3-3.3s3.3 1.5 3.3 3.3c0 1.8-1.5 3.3-3.3 3.3zM40 37.9c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.3c-1.8 0-3.3-1.5-3.3-3.3 0-1.8 1.5-3.3 3.3-3.3 1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3z" />
                    <path d="M49.9 33.3l-7.5-11.7c-.2-.2-.4-.4-.7-.4h-9.2c-.5 0-.8.4-.8.8v20.8c0 .5.4.8.8.8h3.3v-1.7h-2.5v-19h7.9L48.3 34v8.1h-4.2v1.7h5c.5 0 .8-.4.8-.8v-9.2c.1-.2.1-.4 0-.5z" />
                    <path d="M36.7 32.1v-5.8h6.7v-1.7h-7.5c-.5 0-.8.4-.8.8v7.5c0 .5.4.8.8.8h12.5V32l-11.7.1zM32.5 15.4H.8c-.5 0-.8.4-.8.8v26.7c0 .5.4.8.8.8h6.7V42H1.7V17h30v25H15.8v1.7h16.7c.5 0 .8-.4.8-.8V16.2c0-.4-.3-.8-.8-.8z" />
                    <path d="M.8 38.7h5v1.7h-5zM17.5 38.7h14.2v1.7H17.5zM45.8 38.7h3.3v1.7h-3.3zM3.3 18.7h29.2v1.7H3.3zM10.8 42.1h1.7v1.7h-1.7zM39.2 42.1h1.7v1.7h-1.7zM3.3 12.1H15v1.7H3.3zM0 12.1h1.7v1.7H0z" />
                </svg>
            )
        default:
            return (
                null
            )
    }
}

export default guideIconsSecond